//HS iframe form
<template>
  <div class="meetings-iframe-container">
    <iframe
      :src="src"
      width="100%"
      height="650px"
      scrolling="no"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  src: string
}

defineProps<Props>()
</script>

<style scoped lang="scss">
.meetings-iframe-container {
  height: 650px;
  overflow: hidden;
}
</style>
